import { Component,  EventEmitter,  Input, Output } from '@angular/core';
import { AppSurvey, SurveySelectData } from 'globals/store/app.data';
import { ConfirmDeleteData, openConfirmDeleteGetResult } from '../../components/dialog.confirmDelete.component';
import { ManageTimesComponent, ManageTimesDialogData } from './manage-times.component';
import { Wrapper } from '../../components/wrapper.component';
import { getSurveyListOfTimeZonesUsed } from '../../store/reselectors/apps.reselector';
import { openDialogGetResult } from '../../helpers/angular-helpers';
import { MatMenuModule } from '@angular/material/menu';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { ActionButtonComponent } from 'src/app/components/nav-bar/action-button.component';
import { TimeZonePipe, ZonedDatePipe } from 'src/app/services/pipes/timezone.pipe';
import { CommonModule, DatePipe } from '@angular/common';
import { TipTextComponent } from 'src/app/components/misc/tip-text.component';
import { lastValueFrom } from 'rxjs';

@Component({
    selector: 'app-surveys-list',
    template: `
<tip-text [type]="'tip'" [head]="'Tip:'" [body]="'Evaluation forms go to all people logged into your app.'"></tip-text>
<div class="notification-grid surveys">
  <div class="hint" *ngIf="!surveys.length">There are no evaluation forms on the app yet</div>
  <ng-container *ngFor="let survey of surveys">
    <ng-container *ngIf="(!survey.active ? 'Inactive' :
    survey.endTime && survey.endTime < now ? 'Closed' :
    survey.pushTime < now ? 'Open' : 'Scheduled') as status">
      <div class="name" (click)="edit.emit(survey.id)">{{ survey.title || 'Unnamed Evaluation Form' }}</div>
      <div class="push-time">
        <ng-container *ngIf="status === 'Inactive'">Inactive</ng-container>
        <ng-container *ngIf="status !== 'Inactive'">
          {{ survey.pushTime | zonedDatePipe:survey.timeZone | date:" hh:mma d MMM" }} 
          <ng-container *ngIf="!!survey.endTime"> 
            - {{ survey.endTime | zonedDatePipe:survey.timeZone | date:" hh:mma d MMM" }} 
          </ng-container>
          {{ survey.pushTime | timeZoneAbbreviationPipe:survey.timeZone }} ({{ status }})
        </ng-container>
      </div>
      <action-button 
        [text]="status === 'Inactive' ? 'Activate' : 'Edit Times'" 
        (click)="editTimes(survey)"
      ></action-button>
      <div class="options-holder">
        <icon [id]="'action' + survey.id" class="view_opt" [matMenuTriggerFor]="viewOptions" matIcon="more_vert"></icon>
        <mat-menu #viewOptions="matMenu" xPosition="before">
          <button mat-menu-item (click)="confirmDelete(survey, 'action' + survey.id)">Delete</button>
          <button mat-menu-item *ngIf="!!survey.active" (click)="confirmDeactivate(survey, 'action' + survey.id)">Deactivate</button>
          <button mat-menu-item (click)="edit.emit(survey.id)">Edit</button>
        </mat-menu>
      </div>
    </ng-container>
  </ng-container>
</div>
`,
    styleUrls: ['./app-notifications-list.scss'],
    standalone: true,
    imports: [MatMenuModule, IconComponent, ActionButtonComponent, ZonedDatePipe, TimeZonePipe, CommonModule, TipTextComponent, DatePipe, ],
})
export class AppSurveysListComponent extends Wrapper<AppSurveysListComponent> {
  @Input() surveys: AppSurvey[] = []
  @Input() appId: string
  @Output() pushNow: EventEmitter<string> = new EventEmitter()
  @Output() delete: EventEmitter<string> = new EventEmitter()
  @Output() edit: EventEmitter<string> = new EventEmitter()
  @Output() deactivate: EventEmitter<string> = new EventEmitter()
  @Output() update: EventEmitter<AppSurvey> = new EventEmitter()

  async editTimes(survey: AppSurvey) {

    const surveySelectData: SurveySelectData = {
      surveyId: survey.id,
      appId: this.appId
    }
    const timezones = await lastValueFrom(this.store.select(getSurveyListOfTimeZonesUsed, surveySelectData))
    const data: ManageTimesDialogData = {
      startTime: survey.pushTime,
      startName: 'Open',
      endTime: survey.endTime,
      endName: 'Close',
      active: survey.active,
      timeZone: survey.timeZone,
      timezones,
      dialogTitle: 'Edit Evaluation Form Times',
      saveLabel: !survey.active ? 'Activate' : 'Update times'
    }

    const returnData = await openDialogGetResult<ManageTimesDialogData>(this.dialog, ManageTimesComponent, { width: '600px', disableClose: true, data })
    console.log({ returnData })

    if (!returnData) return
    
    const { startTime: pushTime, endTime, timeZone } = returnData
    survey = { ...survey, pushTime, endTime, active: true, timeZone }
    console.log({ survey })
    this.update.emit(survey)

    
  }

  async confirmDelete(survey: AppSurvey, elementId: string) {
    const el = document.getElementById(elementId)
    const rect = el.getBoundingClientRect()
    const data: ConfirmDeleteData = { 
      rect, 
      title: 'Delete Evaluation Form', 
      para: 'This cannot be undone - you will no longer be able to see any answers to this evaluation form', 
      dialog: this.dialog
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return
    this.delete.emit(survey.id)
  }

  async confirmDeactivate(survey: AppSurvey, elementId: string) {
    const el = document.getElementById(elementId)
    const rect = el.getBoundingClientRect()
    const data: ConfirmDeleteData = { 
      rect, 
      title: 'Deactivate Evaluation Form', 
      para: 'The evaluation form will no longer show in the app', 
      deleteButtonText: 'DEACTIVATE',
      dialog: this.dialog
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return
    this.deactivate.emit(survey.id)
  }

}

